<template>
  <div id="app">
    <div>
      <router-view/>
      <div v-show="footerShow" class="footer_parent" style="background-color:#323237;">
        <div class="footer_div">
          <div class="footer_div_left">
            <div class="footer_div_left_title">
              <div class="logo_div">
                <img :src="defaultInformation.logo" alt="">
              </div>
              <div class="phone_div">
                <img src="../static/img/index/phone_fff.png" alt="">
                <div>
                    <p>服务热线</p>
                    <p class="phone_div_des">{{defaultInformation.phone400}}</p>
                </div>
              </div>
            </div>
            <div class="footer_div_left_con">
              <div class="footer_div_left_con_item">
                <p class="footer_div_left_con_des">核心产品</p>
                <p class="cursor" v-for="(item,index) in productsList" :key="index" @click="jumpPath(item.url)">{{item.name}}</p>
              </div>
              <div class="footer_div_left_con_item">
                <p class="footer_div_left_con_des">市场合作</p>
                <p class="cursor" v-for="(item,index) in cooperationList" :key="index" @click="jumpPath(item.url)">{{item.name}}</p>
              </div>
              <div class="footer_div_left_con_item">
                <p class="footer_div_left_con_des">关于我们</p>
                <p class="cursor" v-for="(item,index) in usList" :key="index" @click="jumpPath(item.url)">{{item.name}}</p>
              </div>
              <div class="footer_div_left_con_item" style="width:21vw;text-align:left;color:#ffffff">
                <p class="footer_div_left_con_des" style="border:none">联系我们</p>
                <p>客服电话： {{defaultInformation.phone400}}</p>
                <p style="margin-left:4.5vw;font-weight:bold">{{defaultInformation.phoneNumber}}(全年无休)</p>
                <p>商务合作： {{defaultInformation.email}}</p>
                <p>公司地址： {{defaultInformation.address}}</p>
              </div>
            </div>
          </div>
          <div class="footer_div_right dis_column ali_cen just_cen">
            <p style="width:13vw;font-size:1vw;color:#ffffff;font-weight:bold;margin-bottom:1vw">联系我们</p>
            <img style="width:13vw" :src="defaultInformation.serviceCode" alt="">
          </div>
        </div>
        <div style="font-size:0.732vw;width:100%;display: flex;align-items: center;justify-content: center;flex-direction: column;background-color:#323237;color: #58585b">
            <p style="position: relative">
                <span style="cursor: pointer">Copyright © 2025   |   {{defaultInformation.simpleCompanyName}}    |   {{defaultInformation.icp}}</span>
                <a href="http://beian.miit.gov.cn" target="_blank" style="position: absolute;top: 0;bottom: 0;left: 0;right: 0"></a>
            </p>
            <p style="display: flex;align-items: center;justify-content: center;position: relative">
                <img src="../static/img/pixels.png">
                <span style="cursor: pointer">{{defaultInformation.register}}&nbsp;</span>
                <a :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode='+defaultInformation.simpleRegister" target="_blank" style="position: absolute;top: 0;bottom: 0;left: 0;right: 0"></a>
            </p>
            <p style="display: flex;align-items: center;justify-content: center;position: relative">
                <span style="cursor: pointer">版权所有: {{defaultInformation.companyName}}</span>
            </p>

        </div>
      </div>
    </div> 
    <div class="header_parent"> 
      <el-row class="header">
          <el-col :span="4" class="h100">
            <div class="dis_row ali_cen h100 w100">
              <img :src="defaultInformation.logo_white" style="height:80%">
            </div>
          </el-col>
          <el-col :span="8" class="h100"></el-col>
          <el-col :span="8" class="h100">
            <div class="dis_row just_bet ali_cen h100">
              <div class="h100 pos_re" v-for="(item,i) in $root.indexTabList" :key="i" @click="titleList(i)">
                <p class="tab_title_text color_333">{{item.label}}</p>
                <p class="tab_title_text_line bgc_1090cc" v-show="item.isActive"></p>
              </div>
            </div>
          </el-col>
          <el-col :span="4" class="h100">
            <div class="w100 h100 dis_row ali_cen just_cen phone animated pulse">
              <i class="el-icon-phone-outline color_fca014"></i>
              <p class="color_fca014">15905204389</p>
            </div>
          </el-col>
      </el-row>
    </div>
  </div>
</template>
  
<script>
export default {
  name: 'App',
  data(){
    return{
      defaultInformation:{},
      footerShow:true,
      productsList:[{
        name:'企业彩铃，视频彩铃',
        // url:"/ringone"
      },{
        name:'视频彩铃制作',
        // url:"/video_ringone"
      },{ 
        name:'400电话',
        // url:"/telNum"
      },{
        name:'号码认证',
        url:""
      },{
        name:'铃音录制',
        // url:"/ringoneRecord"
      }],
      cooperationList:[{
        name:'代理产品',
        url:"/cooperation"
      },{
        name:'合作流程',
        url:"/cooperation"
      },{
        name:'代理支撑',
        url:"/cooperation"
      }],
      usList:[{
        name:'公司简介',
        url:'/aboutUs'
      },{
        name:'企业文化',
        url:'/aboutUs'
      },{
        name:'服务优势',
        url:'/aboutUs'
      },{
        name:'平台简介',
        url:'/aboutUs'
      }]
    }
  },
  created(){
    let hostPath = window.location.host
    const script = document.createElement('script');
    // script.src = 'https://ring-project.oss-cn-shanghai.aliyuncs.com/public/official_html/js/dingsheng6.cn.js';
    script.src = 'https://ring-project.oss-cn-shanghai.aliyuncs.com/public/official_html/js/'+hostPath+'.js';
    document.head.appendChild(script);
    setTimeout(() => {
      this.defaultInformation = defaultInformation
    }, 500);
    
    this.$root.indexTabFlag = 0;
    this.titleList(0,'/index')
    this.$router.beforeEach((to, from, next) => {
        if(to.path == '/index'){
          // this.footerShow = false
          this.footerShow = true
        }else{
          this.footerShow = true
        }
        next()
    });
  },
  methods:{
    titleList(i,path){
      this.$root.indexTabList.forEach(item => {
        item.isActive = false
      });
      this.$root.indexTabList[i].isActive = true
      this.$router.replace(this.$root.indexTabList[i].path)
    },
    jumpPath(path){
      if(path){
        this.$router.replace(path)
      }
    },
  } 
}
</script>

<style>
  .header_parent{
    width: 100vw;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10;
    background: hsla(0,0%,100%,.88);
  }
  .footer_parent{
    width: 100vw;
    height: 30vw;
    background-size:100% 100%;
  }
  .header{
    height: 3.4vw;
    width: 75vw;
    margin: 0 auto;
  }
  .bgc_fff{
    background-color:#fff !important;
    /* box-shadow: 8px 8px 15px #efefef; */
  }
  .bgc_d9eaff{
    background-color: #d9eaff !important;
  }
  .color_000{
    color: #000 !important;
  }
  .tab_title_text{
    line-height:3.4vw;
    color:#fff ;
    font-size: 0.85vw;
    font-weight: bold;
  }
  .tab_title_text_line{
    background-color: #fff;
    height: 0.2vw;
    position: absolute;
    bottom: 0px;
    left: 50%;
    width: 1.5vw;
    margin-left: -0.75vw;
  }
  .phone{
    font-size: 0.85vw;
    animation-iteration-count: infinite;
  }
  .phone p{
    margin-left: 0.5vw;
  }
  .phone i{
    font-size: 1.2vw;
  }
  .color_333{
    color: #333;
}
.bgc_1090cc{
  background-color: #1090cc;
}
.color_fca014{
  color:#fca014
}
.goTopDiv{
    width:3.5vw;
    height:3.5vw;
    background-color: rgba(0, 0, 0, 0.4);
    position: fixed;
    bottom:10rem;
    right:3rem;
    border-radius: 50%
  }
  .goTopDiv img{
    width: 2vw;
    height: 2vw
  }
  .footer_div{
    width: 75vw;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .footer_div_left{
    width: 55vw;
    margin-top: 3vw;
  }
  .footer_div_right{
    width: 20vw;
  }
  .footer_div_left_title{
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 5vw;
  }
  .logo_div{
    width: 20vw;
    height: 5vw;
    display: flex;
    justify-content: center;
  }
  .logo_div img{
    height: 100%;
  }
  .phone_div{
    width: 30vw;
    height: 5vw;
  }
  .phone_div{
    height: 5vw;
    border-left: 2px solid rgba(255, 255, 255,0.1);
    display: flex;
    align-items: center;
    font-size: 1vw;
    color: #ffffff;
  }
  .phone_div img{
    height: 3vw;
    width: 3vw;
    margin-left: 2vw;
    margin-right: 1vw;
  }
  .phone_div_des{
    font-size: 2vw;
    font-weight: bold;
    margin-top: 0.5vw;
  }
  .footer_div_left_con{
    width: 100%;
    height: 17vw;
    margin-top: 1vw;
    display: flex;
    justify-content: space-between;
  }
  .footer_div_left_con_des{
    color: #fff;
    font-size: 1.1vw;
    line-height: 4vw;
    margin-bottom: 1vw;
    border-bottom: 0.15vw solid rgba(255, 255, 255,0.2);
  }
  .footer_div_left_con_item{
    font-size: 0.8vw;
    color: rgba(255, 255, 255,0.5);
    width: 9vw;
    line-height: 2.3vw;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue